<template>
  <div class="counter">
    <router-link to="/entQuery">返回</router-link>
    <h2 class="blue_title">企业征信查询办事指南</h2>
    <div>
      <p class="content-text-indent">企业法定代表人本人查询企业信用报告的，应提供本人有效身份证件原件和企业有效证件原件供查验，提交加盖公章的有效身份证件复印件和加盖公章的企业有效证件复印件，同时如实填写《企业信用报告查询申请表》。</p>
      <p class="content-text-indent">企业法定代表人委托代理人查询企业信用报告的，应提供代理人有效身份证件原件、企业有效证件原件和《企业法定代表人授权委托书》原件供查验，提交加盖公章的代理人有效身份证件复印件、加盖公章的企业有效证件复印件、企业法定代表人签名及加盖公章的《企业法定代表人授权委托书》原件，同时如实填写《企业信用报告查询申请表》。</p>
      <p class="content-text-indent">企业有效证件包括：营业执照、事业单位法人证书、社会团体法人登记证书等登记管理部门颁发的合法证照。</p>
    </div>
    <div>
      <router-link :to="{ path: '/docView', query: { fileName: '企业信用报告查询申请表.docx' } }">点击查看《企业信用报告查询申请表》</router-link>
    </div>
    <div>
      <router-link :to="{ path: '/docView', query: { fileName: '企业法定代表人授权委托书.docx' } }">点击查看《企业法定代表人授权委托书》</router-link>
    </div>
    <div class="button-container">
      <div @click="sendEmail">
        <svg t="1705287040036" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12107" height="60"><path d="M735.872 968.96H241.28c-112.256 0-203.264-91.008-203.264-203.264V271.104C38.016 158.848 129.024 67.84 241.28 67.84h494.592c112.256 0 203.264 91.008 203.264 203.264v494.592c0 112.256-91.008 203.264-203.264 203.264z" fill="#00A9FA" p-id="12108" /><path d="M538.112 560.768L768 330.88c-5.504-3.328-11.776-4.736-18.304-4.736H227.84c-5.76 0-11.52 1.28-16.64 3.712l230.912 230.912c26.368 26.368 69.376 26.368 96 0zM192.384 346.752c-3.584 6.016-5.504 12.8-5.504 20.096v302.976c0 8.32 2.56 15.872 6.784 22.144l172.8-171.52-174.08-173.696z" fill="#FFFFFF" p-id="12109" /><path d="M555.648 578.432c-17.408 17.664-40.704 27.392-65.664 27.392-24.832 0-48.256-9.856-65.92-27.392l-39.936-39.936-170.88 169.088c4.48 2.048 9.344 3.072 14.592 3.072h521.856c7.04 0 13.568-1.792 19.328-5.248L597.888 536.192l-42.24 42.24zM785.792 348.544L615.808 518.272l170.496 168.96c2.56-5.248 3.968-11.008 3.968-17.408V366.848c0-6.528-1.408-12.8-4.48-18.304z" fill="#FFFFFF" p-id="12110" /></svg>
        <div class="button-text">发送邮件</div>
      </div>
    </div>
    <el-dialog title="发送邮件" :visible.sync="showSendEmail" width="90%" @close="showSendEmail = false">
      <div class="selected-file">选择发送文件：</div>
      <el-checkbox-group v-model="checkedItems">
        <el-checkbox v-for="item in items" :key="item.value" :label="item.value" class="checkbox-style">
          {{ item.name }}
        </el-checkbox>
      </el-checkbox-group>
      <el-input v-model="email" placeholder="请输入邮箱地址" class="input-padding" />
      <div class="send-div">
        <el-button @click="send">发送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'CounterVue',
  data() {
    return {
      showSendEmail: false,
      email: '',
      items: [
        { value: '企业信用报告查询申请表.docx', name: '《企业信用报告查询申请表》' },
        { value: '企业法定代表人授权委托书.docx', name: '《企业法定代表人授权委托书》' }
      ],
      checkedItems: ['企业信用报告查询申请表.docx', '企业法定代表人授权委托书.docx'],
      totalEmails: 0,
      successfulEmails: 0,
      failedEmails: 0
    }
  },
  mounted() {
    // 初始化字体设置
    const savedFontSize = localStorage.getItem('fontSize') || '中'
    this.selectedFontSize = savedFontSize
    document.documentElement.style.setProperty('--font-size', this.getFontSize(savedFontSize))
    document.documentElement.style.setProperty('--line-height', this.getLineHeight(savedFontSize))
  },
  methods: {
    sendEmail() {
      this.showSendEmail = true
    },
    send() {
      if (this.checkedItems.length === 0) {
        this.$message({
          type: 'warning',
          message: '请至少选择一个文件进行发送'
        })
        return
      }

      if (this.email.trim() === '') {
        this.$message({
          type: 'warning',
          message: '邮箱地址不能为空'
        })
        return
      }

      this.totalEmails = this.checkedItems.length
      this.successfulEmails = 0
      this.failedEmails = 0

      this.checkedItems.forEach(checkedItem => {
        axios.post(this.$config.baseUrl + '/appointment-web/emailController/sendEmail', {
          address: this.email,
          fileName: checkedItem
        })
          .then(response => {
            if (response.data.msg === '邮件发送成功') {
              this.successfulEmails++
            } else if (response.data.msg === '邮件发送失败') {
              this.failedEmails++
            }

            if (this.successfulEmails + this.failedEmails === this.totalEmails) {
              this.handleEmailResult()
            }
          })
          .catch(() => {
            this.failedEmails++

            if (this.successfulEmails + this.failedEmails === this.totalEmails) {
              this.handleEmailResult()
            }
          })
      })
    },
    handleEmailResult() {
      if (this.successfulEmails === this.totalEmails) {
        this.$message({
          type: 'success',
          message: '所有邮件发送成功'
        })
      } else if (this.failedEmails === this.totalEmails) {
        this.$message({
          type: 'error',
          message: '所有邮件发送失败'
        })
      } else {
        this.$message({
          type: 'warning',
          message: '部分邮件发送成功，部分邮件发送失败'
        })
      }

      this.totalEmails = 0
      this.successfulEmails = 0
      this.failedEmails = 0

      this.showSendEmail = false
    },
    getFontSize(size) {
      switch (size) {
        case '小':
          return '14px'
        case '中':
          return '16px'
        case '大':
          return '18px'
        default:
          return '16px'
      }
    },
    getLineHeight(size) {
      switch (size) {
        case '小':
          return '1.5'
        case '中':
          return '1.8'
        case '大':
          return '2.0'
        default:
          return '1.8'
      }
    }
  }
}
</script>

<style scoped>
:root {
  --font-size: 16px;
  --line-height: 1.6;
}

.counter {
  padding: 20px;
  background-color: #f5f5f5;
}

.blue_title {
  text-align: center;
  font-size: var(--font-size, 20px);
  font-weight: normal;
  color: #3b88d6;
}

.content-text-indent {
  text-indent: 2em;
  font-size: var(--font-size, 12px);
  margin: 0;
  color: #999;
  line-height: var(--line-height, 24px);
}

.input-padding {
  padding-bottom: 10px;
}

.button-text {
  font-size: 12px;
}

.button-container {
  width: 15%;
  text-align: center;
  position: fixed;
  bottom: 20px;
  left: 85%;
  transform: translateX(-50%);
  background-color: white;
  padding: 6px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 99;
}

.selected-file {
  font-size: var(--font-size, 16px);
  padding-bottom: 10px;
}

.checkbox-style {
  display: block;
  margin-left:10px;
  padding-bottom: 10px;
}

.send-div {
  text-align: center;
}

.icon {
  width: 45px;
  height: 45px;
}
</style>
